import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const STORAGE_KEY = 'mbk_studio_promo_seen';

export default function StudioPromo() {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (sessionStorage.getItem(STORAGE_KEY)) return;
    const t = setTimeout(() => setShow(true), 2500);
    return () => clearTimeout(t);
  }, []);

  const dismiss = () => {
    sessionStorage.setItem(STORAGE_KEY, '1');
    setShow(false);
  };

  const handleYes = () => {
    sessionStorage.setItem(STORAGE_KEY, '1');
    setShow(false);
    navigate('/ai-studio');
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[9998] flex items-end justify-end p-6 pointer-events-none"
        >
          <motion.div
            initial={{ opacity: 0, y: 30, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.95 }}
            transition={{ duration: 0.4, ease: 'easeOut' }}
            data-testid="studio-promo"
            className="pointer-events-auto bg-card border border-primary/40 rounded-2xl px-5 py-4 shadow-2xl shadow-primary/20 max-w-xs"
          >
            <p className="font-bold text-foreground text-sm mb-3" style={{ fontFamily: 'Syne, sans-serif' }}>
              test out the new mbk studio?
            </p>

            <div className="flex gap-2.5">
              <button
                onClick={handleYes}
                data-testid="studio-promo-yes"
                className="flex-1 bg-primary text-primary-foreground font-bold font-mono-cv text-xs py-2 rounded-lg hover:opacity-90 transition-all"
              >
                yes
              </button>
              <button
                onClick={dismiss}
                data-testid="studio-promo-no"
                className="flex-1 border border-border text-muted-foreground font-mono-cv text-xs py-2 rounded-lg hover:border-primary/40 hover:text-foreground transition-all"
              >
                no
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
